import { isHidden as n } from "./highrise1745.mjs";
var i = function(e) {
  if (n(e))
    return 1 / 0;
  for (var t = 0, r = e.parentNode; r; )
    t += 1, r = r.parentNode;
  return t;
};
export {
  i as calculateDepthForNode
};
